import React, { Component } from 'react'
import propTypes from 'prop-types'
import TextField from 'components/textField'

const moment = require('moment')
const COMMIT_DELAY = 1000

class TimePicker extends Component {
  intToExt = (value) => {
    let cur = moment(this.props.value)
    if (!cur.isValid()) cur = null

    let ret = moment(value, 'HH:mm')
    if (!ret.isValid()) ret = null

    if (cur && ret) {
      ret.date(cur.date())
      ret.month(cur.month())
      ret.year(cur.year())
    }

    return ret ? ret.toDate() : null
  }

  extToInt = (value) => {
    if (value === null) return null
    return moment(value).format("HH:mm")
  }

  state = {
    value: this.extToInt(this.props.value),
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (this.props.value !== nextProps.value) this.setState({ value: this.extToInt(nextProps.value) })
  }

  focus = () => {
    this.input.focus()
  }

  keyDown = (e) => {
    if (e.keyCode === 13) this.commit()   // ENTER
  }

  getValue = () => {
    return this.intToExt(this.state.value)
  }

  change = (e, value) => {
    // Delayed commit
    this.setState({ value })
    if (this.timer) clearTimeout(this.timer)
    this.timer = setTimeout(() => this.commit(e), COMMIT_DELAY)
  }

  blur = (e) => {
    // Immediate commit
    this.commit(e)
  }

  commit = (e = {}) => {
    if (this.timer) clearTimeout(this.timer)
    this.props.onChange(e, this.getValue())
  }

  render() {
    const { ...otherProps } = this.props
    return (
      <TextField
        fullWidth
        {...otherProps}
        type="time"
        value={this.state.value}
        onInputChange={this.change}
        onBlur={this.blur}
        onKeyDown={this.keyDown}
        required={true}
        ref={e => { this.input = e }}
      />
    )
  }
}

TimePicker.propTypes = {
  value: propTypes.instanceOf(Date),
  onChange: propTypes.func,
}

export default TimePicker
